<template lang="pug">
yz-card.mt-4(outlined)
  .pa-6
    .d-flex.align-start.justify-space-between
      div
        .yz-heading-8.text-neutral-700 Assign service to branches
        .yz-regular-body-sm.text-neutral-500 Select where this service is available.
      yz-dropdown(v-model="branchFilter" :items="filterOptions" item-text="text" item-value="value" placeholder="All branches" clearable size="sm" width="150px")
    yz-data-table.mt-4(:headers="tableHeaders" :items="paginatedRows" header-class="yz-medium-body-xs" body-class="yz-regular-body-sm" body-height="64px")
      template(v-slot:item.availability="{ item }")
        template(v-if="item.assigned && item.originallyAssigned")
          yz-badge(v-if="item.bookingEnabled" size="md" color="green-100" text-color="success-500") Available
          yz-badge(v-else size="md" color="red-100" text-color="danger-500") Not available
      template(v-slot:item.toggle="{ item }")
        .text-right
          yz-switch(:key="`switch-${item.id}-${switchRefreshKey}`" :value="item.assigned" size="md" :disabled="busyBranchId === item.id" @input="onToggleBranch(item.id, item.name, $event)")
    yz-pagination.mt-4(v-if="filteredRows.length > 0" v-model="page" :page-size.sync="pageSize" :count="filteredRows.length" type="page" arrow change-page-size)
</template>

<script>
export default {
  props: {
    assignedBranches: { type: Array, default: () => [] },
    branches: { type: Array, default: () => [] },
    originalBranchCompanyIds: { type: Array, default: () => [] },
    bookingEnabledBranchIds: { type: Array, default: () => [] },
    serviceId: { type: [Number, String], default: null },
    companySlug: { type: String, default: '' },
    busyBranchId: { type: [Number, String], default: null },
  },
  data () {
    return {
      page: 1,
      pageSize: 10,
      branchFilter: null,
      filterOptions: [
        { text: 'All branches', value: null },
        { text: 'Assigned only', value: 'assigned' },
        { text: 'Not assigned', value: 'unassigned' },
      ],
      tableHeaders: [
        { text: 'Branches', value: 'name', sortable: false, width: '55%' },
        { text: 'Service available for appointment', value: 'availability', sortable: false },
        { text: '', value: 'toggle', sortable: false, align: 'end' },
      ],
      switchRefreshKey: 0,
    }
  },
  computed: {
    activeAssignedIds () {
      return new Set(this.assignedBranches.filter(b => !b.deleted).map(b => b.company))
    },
    rows () {
      return this.branches.map(b => ({
        id: b.id,
        name: b.name,
        assigned: this.activeAssignedIds.has(b.id),
        bookingEnabled: this.bookingEnabledBranchIds.includes(b.id),
        originallyAssigned: this.originalBranchCompanyIds.includes(b.id),
      }))
    },
    filteredRows () {
      if (this.branchFilter === 'assigned') return this.rows.filter(r => r.assigned)
      if (this.branchFilter === 'unassigned') return this.rows.filter(r => !r.assigned)
      return this.rows
    },
    paginatedRows () {
      const start = (this.page - 1) * this.pageSize
      return this.filteredRows.slice(start, start + this.pageSize)
    },
  },
  watch: {
    branchFilter () { this.page = 1 },
  },
  methods: {
    onToggleBranch (branchId, branchName, value) {
      if (!value && this.serviceId && this.originalBranchCompanyIds.includes(branchId)) {
        this.switchRefreshKey++
        this.$emit('request-unassign', { branchId, branchName })
        return
      }
      const next = [...this.assignedBranches]
      const idx = next.findIndex(b => b.company === branchId)
      if (value) {
        if (idx >= 0) {
          next[idx] = { ...next[idx], deleted: false }
        } else {
          next.push({ company: branchId, deleted: false })
        }
      } else {
        if (idx >= 0) {
          if (this.originalBranchCompanyIds.includes(branchId)) {
            next[idx] = { ...next[idx], deleted: true }
          } else {
            next.splice(idx, 1)
          }
        }
      }
      this.$emit('update:assignedBranches', next)
    },
  },
}
</script>
